// extracted by css-extract-rspack-plugin
export default {"wrapper":"_c8626573","pillWrapper":"_886875ca","viewAllWrapper":"_979e121f"};